module.exports = __webpack_public_path__ + "static/media/12.eb915940.jpg";